import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {RiepilogoGiustificativi} from "@commons/mapping/RiepilogoGiustificativiRecord";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";

import {DateTime} from "luxon";
import {StatoWeekBaseRecord} from "@commons/mapping/StatoWeekBaseRecord";
import {CachePresenze} from "@commons/mapping/CachePresenze";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";
import {AccumuloRecord} from "@commons/mapping/AccumuloRecord";

export interface StatoWeekPLUSRecord extends StatoWeekBaseRecord<RiepilogoOrePlus> {
    index: number, // enumeratore della settimana, da 0..5, INIZIALIZZATO DA loadPresenze()
    hired: boolean,
    giustificativi: RiepilogoGiustificativi[],
    accumuliCHK: AccumuloRecord[], //TODO check tipo!!!
    anomalia: boolean,
    forzabile: boolean,
    currentDay: PresenzeGiornataPlusRecord | null,
}

// N.B. nel progetto AngularJS tale classe si chiamava semplicemente Week
export class StatoWeekPLUSRecord {
    static factory: ObjectFactory<StatoWeekPLUSRecord> = (json?: Partial<StatoWeekPLUSRecord>) => {
        return merge<StatoWeekPLUSRecord, Partial<StatoWeekPLUSRecord> | undefined>({
            //Props da StatoWeekBaseRecord
            annoRif: 0,
            meseRif: 0,
            dtInizioWeek: null,
            dtFineWeek: null,
            minBaseHH: 0,
            maxBaseHH: 0,
            idDip: 0,
            numWeek: 0,
            numWeekKey: 0,
            minWeek: 0,
            maxWeek: 0,
            totali: null,
            giorniPeriodo: 0,
            turniPeriodo: 0,
            basiHHPeriodo: 0,
            ULPeriodo: 0,
            statoWeek: 0,
            statoWeekCavallo: 0,
            swUserName: '',
            swTimeStamp: null,
            richiestaPendente: false,
            countStato: 0,

            //Props da StatoWeekPLUSRecord
            index: 0,
            hired: false,
            giustificativi: [],
            accumuliCHK: [],
            anomalia: false,
            forzabile: false,
            currentDay: null,
        }, json);
    }

    static isLock = function (week: StatoWeekPLUSRecord) {
        return week.statoWeek > 0;
    };

    static isHired = function (week: StatoWeekPLUSRecord) {
        return week.hired;
    };


    static contains = (week: StatoWeekPLUSRecord, day: Pick<PresenzeGiornataPlusRecord, 'dtGiornata'>) => {
        const dtInizioWeek = DateTime.fromISO(week.dtInizioWeek!).startOf('day');
        const dtFineWeek = DateTime.fromISO(week.dtFineWeek!).endOf('day');
        const dtGiornata = DateTime.fromISO(day.dtGiornata!).startOf('day');
        return dtInizioWeek <= dtGiornata && dtFineWeek >= dtGiornata;
    }

    static getRiepilogoGiu = function (week: StatoWeekPLUSRecord, codGiu: string) {
        for (let indGiu = 0; indGiu < week.giustificativi.length; ++indGiu) {
            if (week.giustificativi[indGiu].giustificativo !== null) {
                if (week.giustificativi[indGiu].giustificativo.codGiu === codGiu) {
                    return week.giustificativi[indGiu];
                }
            } else {
                console.log("stranezza...");
            }
        }
        return null;
    };

/*    static getCountAccumuliCHK = function (periodo: StatoWeekPLUSRecord, filter: 'WEEK'|'MONTH') {
        let count = 0;
        for (let indGiu = 0; indGiu < periodo.accumuliCHK.length; ++indGiu) {
            if (periodo.accumuliCHK[indGiu].periodo === 'SETTIMANA') {
                count += (filter === 'WEEK') ? 1 : 0;
            } else {
                count += (filter === 'MONTH') ? 1 : 0;
            }
        }
        return count;
    };*/

    static totalizzaWeek = function (days: PresenzeGiornataPlusRecord[],
                                     cache: CachePresenze,
                                     week: StatoWeekPLUSRecord, iWeek: number, soloMeseRif: boolean, meseRif: number) {

        for (let day = 0; day < 7; day++) {		// per sette giorni...
            const giornata = days[(iWeek) * 7 + day];
            if (giornata && giornata.totali !== null && (soloMeseRif === false || giornata.mese === meseRif)) {

                // Retifico: settimana con giornate utili!
                week.hired = true;

                // aggiorno totali ore
                RiepilogoOrePlus.add(week.totali, giornata.totali);

                // Aggiorno riepilogo giustificativi
                const gruppoCausali = [giornata.causaliHH, giornata.causaliQI];
                for (let indC = 0; indC < gruppoCausali.length; ++indC) {
                    const gruppo = gruppoCausali[indC];
                    for (let indGiu = 0; indGiu < gruppo.length; ++indGiu) {
                        const causale = gruppo[indGiu];
                        if (PresenzeGiustificativo.isValid(causale!)) {
                            let riepilogo = StatoWeekPLUSRecord.getRiepilogoGiu(week, causale!.codGiu);
                            if (riepilogo === null) {
                                const giustificativo = cache.getGiustificativo(causale!.codGiu);
                                riepilogo = new RiepilogoGiustificativi({
                                    giustificativo: giustificativo!,
                                    quantita: 0
                                });
                                week.giustificativi.push(riepilogo);
                            }
                            if (gruppo === giornata.causaliQI) {
                                // hotfix!!! casto stringa in valore numerico per poterla sommare...
                                // todo da rivedere!!!
                                // @ts-ignore
                                if (typeof causale.quantita === 'string' || causale.quantita instanceof String) {
                                    try {
                                        // todo da rivedere!!!
                                        // @ts-ignore
                                        causale.quantita = parseFloat(causale.quantita);
                                        if (isNaN(causale!.quantita)) {
                                            causale!.quantita = 0;
                                        }
                                    } catch (error) {
                                        causale!.quantita = 0;
                                    }
                                }
                            }
                            riepilogo.quantita += causale!.quantita;
                        }
                    }
                }
            }
        }
    };
}

